<template>

    <transition name="fade-in" >
    
        <div class="modal-bg" v-if="open" >
        
            <div class="w-98 
                        h-auto 
                        p-10 
                        bg-white 
                        rounded-cs-md 
                        shadow-xl" 
                        
            >

                <div class="flex items-center" >

                    <p class="text-xl flex-grow" >New User</p>

                    <button class="btn-close" @click.prevent="closeModal" ></button>

                </div>

                <form class="grid gap-4 py-6" >

                    <c-input type="email" label="Email" placeholder="eg: janedoe@gmail.com" v-model="newUser.email" />

                    <c-input type="text" label="First Name" placeholder="eg: Jane" v-model="newUser.firstName" />

                    <c-input type="text" label="Last Name" placeholder="eg: Doe" v-model="newUser.lastName" />

                    <c-select label="Role" placeholder="Select Role" :list="roles" v-model="newUser.role" />

                    <button class="btn-primary" @click.prevent="addUser" >Add User</button>

                </form>

            </div>
        
        </div>

    </transition>

</template>

<script>

    import { ref, reactive, computed } from 'vue'
    import { useStore } from 'vuex'

    import cInput from './input'
    import cSelect from './select'

    export default {
    
        name: 'New user',

        components: { cInput, cSelect },

        props: {
            open: Boolean
        },

        setup( props, { emit } ) {

            const store = useStore()
            const users = computed(() => store.state.users.users )
            const roles = computed(() => store.state.users.roles.map( r => ({ id: r.id, name: r.type })) )

            console.log(users.value)

            const newUser = reactive({

                email: '',
                firstName: '',
                lastName: '',
                role: []

            })

            const closeModal = () => emit('close')

            const addUser = () => {

                const copyUsers = [...users.value]

                const id = copyUsers.reduce((prev, curr) => (prev.id > curr.id) ? prev : curr, 1).id + 1

                const user = {

                    id: id,
                    firstName: newUser.firstName,
                    lastName: newUser.lastName,
                    email: newUser.email,
                    role: newUser.role[0].name

                }

                store.commit('addUser', user)

                closeModal()

            }

            return {
                roles,
                newUser,
                addUser,
                closeModal
            }

        }

    }

</script>

<style scoped>

    .modal-bg {

        backdrop-filter: blur(4px);

        @apply 
            w-full 
            h-screen 
            absolute
            top-0
            z-50
            left-0 
            bg-ch-blue 
            bg-opacity-75
            flex
            items-center
            justify-center

    }

</style>